/* @flow
    This file contains all common endpoints/urls for use in permits mono repo.
*/

export * from './shared-constants';

// REDUX constants
export const SHARED_PREFIX = 'SHARED_PREFIX_';
export const SET_IMAGE_URL = 'SET_IMAGE_URL';

export const DEFAULT_PERMIT_TYPES_OPTIONS = [
    "Employee",
    "Research",
    "Search & Rescue",
    "Special Use",
    "Other"
]

export const DISPLAY_PERMIT_VENUE_PAGE = 'displayPermitVenuePage';
export const DISPLAY_PAY_LATER = 'permitsPayLater';

// image url
const API_ROOT = process.env.API || '';
export const imageUrl = (permitId: string) => `${API_ROOT}/media/public/asset/${permitId}`;

export const apiUrls = {
    imageUrl
};

export const LOCAL_DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mm A z';
